import React, { useState, useEffect, useRef } from 'react';
import { InputIcon } from 'primereact/inputicon';
import { Tooltip } from 'primereact/tooltip';


export default function DisplayStatusEquipamento(props){
    


    if(props.equipamentoNovo === 't'){
        return <div className='' >
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>{props.enderecoip}</span></div>
                    <div style={{textAlign : 'center'}}><i className="pi pi-times mt-2  text-2xl" style={{color: '#C62828'}}/></div>
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>Desabilitada</span><br/></div>
                </div>
    }
    if(props.ativo == 'f'){
        return <div className=''  >
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>{props.enderecoip}</span></div>
                    <div style={{textAlign : 'center'}}><i className="pi pi-times-circle mt-2 text-2xl" style={{color: '#B71C1C'}}/></div>
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>Desabilitada</span><br/></div>
                </div>
    }

    if(props.dias > 0){
        return <div className='' style={{cursor:'pointer'}} {...props} >
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>{props.enderecoip}</span><br/></div>
                    <div style={{textAlign : 'center'}}>
                        <i className="pi pi-link mt-1 text-warn text-2xl" 
                        data-pr-tooltip="Equipamento está sem conexão"
                        data-pr-position="right"
                        style={{color: 'rgba(221, 92, 18, 1)'}} ></i>
                        <Tooltip target=".pi-times-circle" />    
                    </div>
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>Sem Conexão</span><br/></div>
                </div>
    }

    switch(props.status){
        case 1: // desconhecido
            return <div className=''  >
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>{props.enderecoip}</span><br/></div>
                    <div style={{textAlign : 'center'}}><i className="pi pi-times-circle mt-1 text-warn text-2xl" style={{color: '#FB8C00'}} ></i></div>
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>Desconhecido</span><br/></div>
                </div>
        break;
        case 2: // pronto
            return <div className=''  >
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>{props.enderecoip}</span><br/></div>
                    <div style={{textAlign : 'center'}}><i className="pi pi-check-circle mt-1 text-warn text-2xl" style={{color: '#00695C'}} ></i></div>
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>Pronta</span><br/></div>
                </div>
        break;
        case 3: // energy saving
            return <div className=''  >
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>{props.enderecoip}</span><br/></div>
                    <div style={{textAlign : 'center'}}><i className="pi pi-power-off mt-1 text-warn text-2xl" style={{color: '#FFA000'}} ></i></div>
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>E Saving</span><br/></div>
                </div>
        break;
        case 4: // imprimindo
            return <div className=''  >
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>{props.enderecoip}</span><br/></div>
                    <div style={{textAlign : 'center'}}><i className="pi pi-print mt-1 text-warn text-2xl" style={{color: '#2E7D32'}} ></i></div>
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>Imprimindo</span><br/></div>
                </div>
        break;
        case 5: // ocorrencia
            return <div className='' >
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>{props.enderecoip}</span><br/></div>
                    <div style={{textAlign : 'center'}}><i className="pi pi-wrench mt-1 text-warn text-2xl" style={{color: '#C62828'}} ></i></div>
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>Ocorrência</span><br/></div>
                </div>
        break;
        case 6: // atenção
            return <div className='' >
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>{props.enderecoip}</span><br/></div>
                    <div style={{textAlign : 'center'}}><i className="pi pi-exclamation-triangle mt-1 text-warn text-2xl" style={{color: '#F57C00'}} ></i></div>
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>Atenção</span><br/></div>
                </div>
        break;
        case 7: // atolamento
            return <div className='' >
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>{props.enderecoip}</span><br/></div>
                    <div style={{textAlign : 'center'}}><i className="pi pi-wave-pulse mt-1 text-warn text-2xl" style={{color: '#C62828'}} ></i></div>
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>Atolamento</span><br/></div>
                </div>
        break;
        case 8: // porta aberta
            return <div className='' >
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>{props.enderecoip}</span><br/></div>
                    <div style={{textAlign : 'center'}}><i className="pi pi-sign-out mt-1 text-warn text-2xl" style={{color: '#FFA000'}} ></i></div>
                    <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>Porta Aberta</span><br/></div>
                </div>
        break;
        default: // desconhecido
            return <div className='' >
            <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>{props.enderecoip}</span><br/></div>
            <div style={{textAlign : 'center'}}><i className="pi pi-question-circle mt-1 text-warn text-2xl" style={{color: '#283593'}} ></i></div>
            <div style={{textAlign : 'center'}}><span style={{fontSize : '9px'}}>Desconhecido</span><br/></div>
        </div>
        break
    }
    
}